import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Paging } from '@idto';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PaginationComponent
{
  //#region Backfields
  private _paging: Paging;
  //#endregion

  get paging(): Paging
  {
    return this._paging;
  }
  @Input() set paging(value: Paging)
  {
    if (value && value.friendlyLinkTemplate)
    {
      value.linkTemplate = value.friendlyLinkTemplate;
    }

    this._paging = value;
    this.isCurrentPageMoreThanFirst = this._paging?.currentPage > 1;
    this.isCurrentPageLessThenLast = this._paging?.currentPage < this._paging?.pageCount;
    this.previousValue = this._paging?.currentPage;
  }

  public isCurrentPageMoreThanFirst: boolean;
  public isCurrentPageLessThenLast: boolean;

  private previousValue: number;

  @ViewChild('inputValue') public inputValue: ElementRef;
  @Input() public expandOnDesktopRes: boolean = false;
  @Output() private readonly changePageEventEmitter: EventEmitter<number> = new EventEmitter<number>();

  constructor(private changeDet: ChangeDetectorRef, private sanitizer: DomSanitizer)
  {

  }

  public changeForPreviewPage(): void
  {
    if (this._paging.currentPage > 1)
    {
      this.changePage(--this._paging.currentPage);
    }
  }

  public changeForNextPage(): void
  {
    if (this.isCurrentPageLessThan(this._paging.pageCount))
    {
      this.changePage(++this._paging.currentPage);
    }
  }

  public changePage(pageNumber: number): void
  {
    this.changePageEventEmitter.emit(pageNumber);
    this.changeDet.detectChanges();
  }

  public isCurrentPageLessThan(pageNumber: number): boolean
  {
    return this._paging.currentPage < pageNumber;
  }

  public isCurrentPageMoreThan(pageNumber: number): boolean
  {
    return this._paging.currentPage > pageNumber;
  }

  public changeByEnter($event): void
  {
    if ($event.keyCode == 13)
    {
      if (isNaN(this.inputValue.nativeElement.value))
      {
        this.inputValue.nativeElement.value = this.previousValue;
        return;
      }
      if (this.inputValue.nativeElement.value > this._paging.pageCount)
      {
        this.changePageEventEmitter.emit(this._paging.pageCount);
        return;
      }
      if (this.inputValue.nativeElement.value <= this._paging.pageCount && this.inputValue.nativeElement.value >= 1)
      {
        this.changePageEventEmitter.emit(this.inputValue.nativeElement.value);
      }
      if (this.inputValue.nativeElement.value < 1)
      {
        this.changePageEventEmitter.emit(1);
      }
      this.previousValue = this.inputValue.nativeElement.value;
    }
  }

  public changeByBlur(): void
  {
    if (isNaN(this.inputValue.nativeElement.value))
    {
      this.inputValue.nativeElement.value = this.previousValue;
      return;
    }
    if (this.inputValue.nativeElement.value == this._paging.currentPage)
    {
      return;
    }
    if (this.inputValue.nativeElement.value > this._paging.pageCount)
    {
      this.changePageEventEmitter.emit(this._paging.pageCount);
      return;
    }
    if (this.inputValue.nativeElement.value <= this._paging.pageCount && this.inputValue.nativeElement.value >= 1)
    {
      this.changePageEventEmitter.emit(this.inputValue.nativeElement.value);
    }
    if (this.inputValue.nativeElement.value < 1)
    {
      this.changePageEventEmitter.emit(1);
    }
    this.previousValue = this.inputValue.nativeElement.value;
  }

  public createLink = PaginationComponent.createLink;

  static createLink(paging: Paging, pageNumber: number): string
  {
    if (paging && paging.friendlyLinkTemplate)
    {
      return paging.friendlyLinkTemplate.replace('{PAGE}', pageNumber.toString());
    }
    else
    {
      return window.location.pathname + '?' + paging.linkTemplate.replace('{PAGE}', pageNumber.toString());
      //return this.sanitizer.bypassSecurityTrustUrl(window.location.pathname + '?' + paging.linkTemplate.replace('{PAGE}', pageNumber.toString()));
    }
  }

  public sanitize(url: string): SafeUrl
  {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }
}
